export var statuses = ['canceled', 'withdrawn', 'ready_for_visa', 'ready_to_submit', 'rejected', 'submitted'];